import { styled } from '@mui/material/styles';
import { NavLink } from 'react-router-dom';

export const Header = styled('header')(({ theme }) => ({
  alignItems: 'center',
  background: theme.color.primary.main,
  boxSizing: 'border-box',
  color: theme.color.primary.contrast,
  display: 'flex',
  paddingBottom: theme.spacing(0.75),
  paddingTop: theme.spacing(0.75),
  position: 'sticky',
  top: 0,
  zIndex: theme.layer.above,
  lineHeight: '1.15'
}));

export const LinkContainer = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexGrow: 1,
  height: '100%',
  margin: `0 ${theme.spacing(-4)}`,
  padding: `0 ${theme.spacing(10.5)}`
}));

export const StyledNavLink = styled(NavLink)(({ theme }) => ({
  boxSizing: 'border-box',
  color: 'inherit',
  fontSize: theme.fontSize.large,
  textDecoration: 'none',
  margin: `0 ${theme.spacing(1.5)}`,
  '&.active': {
    borderBottom: `1px solid`
  }
}));
